// src/hooks/useConfirmationModal.js

import { useDispatch } from 'react-redux';
import { Modal } from 'antd';

const { confirm } = Modal;

const useConfirmationForBulkDeleteModal = () => {
  const dispatch = useDispatch();

  const showConfirm = (onAccept, count) => {
    confirm({
      title: 'Do you want to all these records?',
      content: `There are a total of ${count} records that will be deleted.\n\nTHIS ACTION CANNOT BE UNDONE!`,
      onOk() {
        dispatch(onAccept)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  return showConfirm;
};

export default useConfirmationForBulkDeleteModal;
